import { lazy, Suspense } from 'react';
import './charts.css';
import { ChartPlaceholder } from './ChartPlaceholder';
import type { TrendChartProps } from './TrendChartImpl';

// Lazy-grens — zie PriceChart.tsx voor de toelichting.
const TrendChartImpl = lazy(() =>
  import('./TrendChartImpl').then(m => ({ default: m.TrendChart })),
);

export type { TrendChartProps } from './TrendChartImpl';

export function TrendChart(props: TrendChartProps) {
  return (
    <Suspense fallback={<ChartPlaceholder />}>
      <TrendChartImpl {...props} />
    </Suspense>
  );
}
